export default __webpack_public_path__ + "static/media/head-1.dc09bb10.svg";